var exports = {
  "tT": "x127c5a35--26c313--sort-container",
  "s7": "x127c5a35--26c313--sort-list",
  "kl": "x127c5a35--26c313--sort-list-item",
};

module.exports = exports;
